export const contactsSaveViews = {
    grid: 'grid',
    conflicts: 'conflicts'
};
